import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '../routes';
import './Navigation.css';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-content">
          <NavLink to={ROUTES.CREATE} className="logo">
            StorySparkle
          </NavLink>
          
          {/* Mobile menu toggle button */}
          <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          
          <ul className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
            <li>
              <NavLink 
                to={ROUTES.CREATE} 
                className={({ isActive }) => isActive ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                Create
              </NavLink>
            </li>
            <li>
              <NavLink 
                to={ROUTES.LIBRARY} 
                className={({ isActive }) => isActive ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                Library
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
